export var ExperimentConfig = {
    RBExperimentProduction: {
        flagKey: 'rb-experiment-production',
        variants: ['control', 'treatment'],
    },
    // DEAP-3695: gates the top "Other designs you might like" (offsite) swimlane on
    // the PDP. Defaults to off (no enrolment) so the swimlane is hidden for everyone;
    // the `control` variant re-shows it (the intact above-the-fold experience).
    OffsiteSimilarDesigns: {
        flagKey: 'rb-offsite-similar-designs-pdp',
        variants: ['control', 'treatment'],
    },
    // DEAP-3692: ships a Checkout CTA in the Cart Tray sticky footer.
    // Defaults to 'off' when the flag is absent from Amplitude, which is treated as
    // treatment (show Checkout) — see CartItemsTray.tsx. 'control' restores View Cart
    // for the future A/B test.
    CartTrayCheckoutCta: {
        flagKey: 'rb-cart-tray-checkout-cta',
        variants: ['control', 'treatment'],
    },
};
export var AMPLITUDE_OFF_ENROLMENT = 'off';
